import styled from "@emotion/styled"

export const MainContainer = styled.div`
  background: #000;

  margin-top: 10px;
  padding: 50px 0;
`

export const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const InnerContainer = styled.div`
  width: 80%;
  margin: auto;
  display: grid;
  /* grid-template-columns: auto auto auto; */
  grid-column-gap: 30px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(308px, 1fr));
  /* grid-gap: 44px; */
  @media (max-width: 369px) {
    grid-template-columns: repeat(auto-fit, minmax(259px, 1fr));
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  width: 50%;
  margin: auto;

  @media (max-width: 805px) {
    width: 84%;
  }
  @media (max-width: 600px) {
    flex-direction: column;
  }
`

export const ModalContainer = styled.div`
  /* height: 300px; */
`

export const Loadmore = styled.div`
  /* background-image: linear-gradient(90deg, #4f3ec8 0%, #8957f6 100%); */
  border: 1px solid #4f3ec8;
  border: 1px solid #fff;
  /* linear-gradient(
      to right,
      #fd8a66 0%,
      #fd4c72 49%,
      #fd387c 85%,
      #fd2384 100%
    ); */
  background: #000;
  width: 171px;
  height: 47px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Rubik;
  font-weight: 700;
  font-size: 17px;
  color: #fff;
  margin: auto;
  cursor: pointer;
`

export const GradientHeading = styled.div`
  background: linear-gradient(to right, #30cfd0 0%, #330867 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: Montserrat, sans-serif;
  font-size: 50px;
  font-weight: 700;
`

export const Track = styled.div`
  background: linear-gradient(to right, #f15786, #767ff0);
  background: linear-gradient(
    to right,
    #fd8a66 0%,
    #fd4c72 49%,
    #fd387c 85%,
    #fd2384 100%
  );
  background-image: linear-gradient(90deg, #4f3ec8 0%, #8957f6 100%);
  padding: 0 20px;
  height: 54px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: Rubik;
  font-weight: 600;
  margin-bottom: 30px;

  :hover {
    background: #000;
    border: 1px solid #fff;
    cursor: pointer;
  }
`

export const ScrollContainer = styled.div`
  overflow-x: hidden;
  padding-right: 12px;
  @media (max-width: 560px) {
    height: 300px;
  }
`

export const SubmitButton = styled.div`
  margin: auto;
  width: 200px;
  height: 50px;

  border-radius: 50px;

  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Rubik;
  font-weight: 600;
  font-size: 16px;

  margin-top: 23px;
  margin-right: 20px;

  background-color: #fff;
  color: #282831;

  @media (max-width: 600px) {
    margin: auto;
    margin-top: 23px;
  }
  :hover {
    cursor: pointer;
    background-color: #282831;
    color: #fff;
  }
`

export const Heading = styled.h1`
  margin-bottom: 24px;
  color: #ffffff;
  font-family: Montserrat, sans-serif;
  font-size: 50px;
  font-weight: 700;
  line-height: 2em;
  text-align: center;
  background: linear-gradient(to right, #30cfd0 0%, #330867 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 560px) {
    font-size: 36px;
    line-height: 41px;
    margin: ${props => props.whyattend && "auto"};
    margin-bottom: 35px;
    width: ${props => (props.whyattend ? "87%" : "81%")};
    text-align: ${props => (props.whyattend ? "left" : "center")};
  }
  @media (max-width: 370px) {
    font-size: 34px;
    width: ${props => (props.whyattend ? "87%" : "81%")};
    line-height: 45px;
  }
  @media (max-width: 340px) {
    width: ${props => (props.whyattend ? "95%" : "81%")};
  }
`
